import {RemotePostHelpDeskNewSac} from 'data/usecases/private/helpdesk-flow';
import {PostHelpDeskNewSac} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {HelpDeskFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makePostHelpDeskNewSac = (): PostHelpDeskNewSac =>
	new RemotePostHelpDeskNewSac(
		makeBFFApiUrl(HelpDeskFlowEndpoints.newSac),
		makeAuthorizeHttpClientDecorator(),
	);
